<script>
  import {
    faCheck,
    faChevronDown,
    faChevronUp,
    faMap,
    faTimes,
  } from "@fortawesome/free-solid-svg-icons"
  import L from "leaflet"
  import { LIcon, LMap, LMarker, LTileLayer, LTooltip } from "vue2-leaflet"
  import SearchSelect from "@/core/components/SearchSelect"

  export default {
    components: {
      LMap,
      LTileLayer,
      LMarker,
      LIcon,
      LTooltip,
      SearchSelect,
    },
    props: {
      sectionPoint: {
        type: Object,
        required: true,
      },
      isModal: {
        type: Boolean,
        default: false,
      },
    },
    data: () => {
      return {
        faChevronDown,
        faChevronUp,
        faCheck,
        faTimes,
        faMap,
        loader: false,
        loaderSearch: false,
        loaderMap: false,
        showAllButtons: true,
        showButtonOriginPoints: true,
        showButtonPoints: true,
        showButtonDestinyPoints: true,
        //Info Api Google
        apiKeyGoogle: "AIzaSyAkcloxsrUNIO4Z0JInU_L5Hp9zHTHvN9c",
        latSearchGgle: "",
        lngSearchGgle: "",
        addressSearchGgle: "",
        numberAddressSearchGgle: "",
        cityAddressSearchGgle: "",
        zipAddressSearchGgle: "",
        districtAddressSearchGgle: "",
        title: "Linhas",
        errors: false,
        searchAddress: {
          street: "",
          number: "",
          district: "",
          zip: "",
          city: "",
        },
        line: {
          line: "",
          name: "",
          itinerary: "",
          ordTravel: "",
          classification: "",
          landing: "",
          originPoint: {},
          destinyPoint: {},
          points: [],
          markers: [],
        },
        posSanfOpen: 0,
        countPointsNotOk: 0,
        hideCardPointSessions: false,
        indexAlterPoint: "",
        block: false,
        hideCardMap: false,
        messageAlert: false,
        showMessageAlert: false,
        typePoint: "",
        textAlert: "",
        subTextAlert: "",
        search: "",
        closed: 0,
        zoom: 7.5,
        zoomMiniMap: 9,
        center: L.latLng(-27.597_456, -48.533_66),
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        withPopup: L.latLng(47.413_22, -1.219_482),
        withTooltip: L.latLng(47.414_22, -1.250_482),
        currentZoom: 7.5,
        currentCenter: L.latLng(-27.597_456, -48.533_66),
        showParagraph: false,
        mapOptions: {
          zoomSnap: 0.5,
          scrollWheelZoom: true,
        },
        icon: L.icon({
          iconUrl:
            "https://www.shareicon.net/data/512x512/2016/05/29/772542_interface_512x512.png",
          iconSize: [48, 48],
          iconAnchor: [16, 37],
        }),
        staticAnchor: [16, 37],
        customText: "Foobar",
        iconSize: [38, 38],
        firstIcon:
          "https://www.shareicon.net/data/512x512/2016/05/29/772542_interface_512x512.png",
        middleIcon:
          "https://www.shareicon.net/data/512x512/2016/05/29/772542_interface_512x512.png",
        lastIcon:
          "https://www.shareicon.net/data/128x128/2015/09/17/642215_flag_512x512.png",
        showMap: true,
        showMiniMap: false,
        loadTimeMap: true,
        error: {
          nmlocalidade: false,
          delocalidade: false,
        },
      }
    },
    mounted() {
      if (this.sectionPoint.gelat !== "" && this.sectionPoint.gelng !== "") {
        this.line.markers.push({
          lat: this.sectionPoint.gelat,
          lng: this.sectionPoint.gelng,
          name: this.sectionPoint.nmlocalidade,
          description: this.sectionPoint.delocalidade,
        })
      }
    },
    watch: {
      sectionPoint: {
        handler() {
          this.line.markers = []
          this.line.markers.push({
            lat: this.sectionPoint.gelat,
            lng: this.sectionPoint.gelng,
            name: this.sectionPoint.nmlocalidade,
            description: this.sectionPoint.delocalidade,
          })
        },
        deep: true,
      },
    },
    methods: {
      zoomUpdate(zoom) {
        this.currentZoom = zoom
      },
      centerUpdate(center) {
        this.currentCenter = center
      },
      showLongText() {
        this.showParagraph = !this.showParagraph
      },
      removeMarker(index) {
        this.line.markers.splice(index, 1)
      },
      verifyPoints() {
        if (this.line.markers.length) {
          return false
        }
      },
      blockAdd() {
        this.block = true
      },
      showAdd() {
        if (this.hideCardPointSessions) {
          this.block = false
        }
      },
      checkNumLinhas() {
        if ((this.sectionPoint.numlinhasativas || 0) > 0) {
          this.$nextTick(() => {
            this.sectionPoint.flsituacao = 1
          })

          this.$toast.warning({
            title: "Atenção",
            message:
              "Este ponto de seção possui linhas ativas e não pode ser inativado.",
          })
          return
        }
      },
      closeSelectSessions() {
        this.typePoint = ""
        this.hideCardMap = false
      },
      setHideCardPosition() {
        this.countPointsOk()
        let h = this.setHideChideCardPointSessions
        this.setHideChideCardPointSessions = !h
      },
      convertVariablesInMarks() {
        let markOrigin = {
          id: this.line.originPoint.idpontosecao,
          lat: this.line.originPoint.gelatitude,
          lng: this.line.originPoint.gelongitude,
          name: this.line.originPoint.nmlocalidade,
          description: this.line.originPoint.delocalidade,
        }

        this.line.markers.push(markOrigin)

        for (let m of this.line.points) {
          if (
            m.origin_point.idpontosecao !==
              this.line.originPoint.idpontosecao &&
            m.origin_point.idpontosecao !== this.line.destinyPoint.idpontosecao
          ) {
            let markPoints = {
              id: "",
              lat: "",
              lng: "",
              name: "",
              description: "",
            }

            markPoints.id = m.origin_point.idpontosecao
            markPoints.lat = m.origin_point.gelatitude
            markPoints.lng = m.origin_point.gelongitude
            markPoints.name = m.origin_point.nmlocalidade
            markPoints.description = m.origin_point.delocalidade

            this.line.markers.push(markPoints)
          }
        }

        let markDestiny = {
          id: this.line.destinyPoint.idpontosecao,
          lat: this.line.destinyPoint.gelatitude,
          lng: this.line.destinyPoint.gelongitude,
          name: this.line.destinyPoint.nmlocalidade,
          description: this.line.destinyPoint.delocalidade,
        }

        this.line.markers.push(markDestiny)

        this.countPointsOk()
      },
      countPointsOk() {
        let count = 0
        let maxPoints = this.line.markers.length - 2

        for (let m of this.line.markers) {
          if (m.update) {
            count += 1
          }
        }

        this.countPointsNotOk = maxPoints - count
      },
      setFormSearchNull() {
        this.searchAddress = {
          street: "",
          number: "",
          district: "",
          zip: "",
          city: "",
        }
      },
      addMarker(event) {
        this.sectionPoint.gelat = event.latlng.lat
        this.sectionPoint.gelng = event.latlng.lng

        if (!this.messageAlert && this.hideCardMap && !this.block) {
          event.latlng.position = this.typePoint
          event.latlng.name = "Ponto de seção"
          this.line.markers.push(event.latlng)
          this.typePoint = ""
          this.hideCardMap = false
        }
        this.verifyPoints()
      },
      submit() {
        this.$emit("submit")
      },
      goBack() {
        if (this.isModal) {
          this.$emit("cancel")
        } else {
          this.$router.go(-1)
        }
      },
      setCity(city) {
        this.sectionPoint.numunicipio = city.idmunicipio
      },
      validateForm() {
        this.errors = false
        if (!this.sectionPoint.nmlocalidade) {
          this.errors = true
          this.$toast.error({
            title: "Erro",
            message: "Nome da localidade é obrigatório.",
          })
        }
        if (!this.sectionPoint.delocalidade) {
          this.errors = true
          this.$toast.error({
            title: "Erro",
            message: "Descrição é obrigatória.",
          })
        }
        if (!this.sectionPoint.numunicipio) {
          this.errors = true
          this.$toast.error({
            title: "Erro",
            message: "Cidade é obrigatória.",
          })
        }
        if (!(this.sectionPoint.gelat || this.sectionPoint.gelng)) {
          this.errors = true
          this.$toast.error({
            title: "Erro",
            message: "Selecione um ponto no mapa.",
          })
        }
        if (!this.errors) {
          this.submit()
        }
      },
    },
  }
</script>

<template>
  <div class="px-2 my-4 sm:px-6">
    <form
      @submit.prevent="validateForm"
      id="travel-form"
      class="flex flex-col space-y-4"
    >
      <div class="w-full p-2">
        <div class="grid gap-5 grid-cols-1 md:grid-cols-12 mb-2 px-3">
          <div class="col-span-6">
            <label class="form-label">Nome da localidade</label>
            <input
              id="nmlocalidade"
              v-model="sectionPoint.nmlocalidade"
              type="text"
              class="form-input"
              :class="{
                'bg-red-100 border-red-400':
                  error.nmlocalidade &&
                  !sectionPoint.nmlocalidade
              }"
            >
          </div>
          <div class="col-span-6">
            <label class="form-label">Município</label>
            <div>
              <SearchSelect
                :selected.sync="sectionPoint.city"
                :search-keys="[]"
                :search-remote="true"
                :lazy-load="true"
                :option-value="city => city.nmmunicipio"
                options-url="/api/spl-navegantes/municipios/"
                option-key="id"
                field-class="py-3"
                name="nmmunicipio"
                placeholder="Selecione uma cidade..."
                @changed="setCity"
              />
            </div>
          </div>
        </div>
        <div class="grid gap-5 grid-cols-1 md:grid-cols-12 mb-2 px-3">
          <div class="col-span-12">
            <div class="flex flex-col w-full">
              <label class="form-label">Descrição</label>
              <div>
                <input
                  id="delocalidade"
                  v-model="sectionPoint.delocalidade"
                  class="form-input"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full p-2">
          <div
            class="flex-col messageAlert"
            v-if="loaderMap"
            style="background-color: #ffffff; position: inherit; height: 100vh"
          >
            <div class="p-2">
              <img src="@/core/assets/images/loader-logo.gif">
            </div>
          </div>
          <div
            class="flex items-center w-full justify-content-center h-300"
            v-bind:class="{ 'h-500': showMap }"
          >
            <l-map
              v-if="showMap && loadTimeMap"
              :zoom="zoom"
              :center="center"
              :options="mapOptions"
              @update:center="centerUpdate"
              @update:zoom="zoomUpdate"
              @click="addMarker"
              style="z-index: 0;"
            >
              <l-tile-layer :url="url" :attribution="attribution"/>
              <div v-if="messageAlert" class="flex-col messageAlert">
                <div class="p-2">{{ textAlert }}</div>
                <div class="p-2">{{ subTextAlert }}</div>
                <div
                  class="p-2 card-info-map box-search-map"
                  v-if="typePoint === 'sessionPoint'"
                  @mouseover="blockAdd()"
                  @mouseleave="showAdd()"
                ></div>
              </div>
              <l-marker
                v-for="(marker, index) in line.markers"
                :key="index"
                :lat-lng="marker"
                :icon="icon"
              >
                <l-icon
                  v-if="index === 0"
                  :icon-url="firstIcon"
                  :icon-size="iconSize"
                ></l-icon>
                <l-icon
                  v-else-if="index !== line.markers.length - 1"
                  :icon-url="middleIcon"
                  :icon-size="iconSize"
                ></l-icon>
                <l-icon
                  v-else
                  :icon-url="lastIcon"
                  :icon-size="iconSize"
                ></l-icon>
                <l-tooltip
                  :options="{
                    permanent: false,
                    interactive: true
                  }"
                >
                  <div>
                    <div v-if="index === 0" class="tooltip-map first-point">
                      {{ marker.name }}
                    </div>
                    <div
                      v-else-if="index === line.markers.length - 1"
                      class="tooltip-map first-point"
                    >
                      {{ marker.name }}
                    </div>
                    <div v-else class="tooltip-map">{{ marker.name }}</div>
                  </div>
                </l-tooltip>
              </l-marker>
            </l-map>
          </div>
        </div>
      </div>

      <!-- Rodapé com Ações -->
      <div
        class="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mt-4 p-4 border-t border-gray-200"
      >
        <!-- Status Ativo/Inativo -->
        <div class="flex items-center gap-6">
          <div class="flex items-center">
            <input
              type="radio"
              class="h-5 w-5 mr-2"
              v-bind:value="1"
              v-model="sectionPoint.flsituacao"
            >
            <label class="form-label mb-0">Ativo</label>
          </div>
          <div class="flex items-center">
            <input
              type="radio"
              class="h-5 w-5 mr-2"
              v-model="sectionPoint.flsituacao"
              v-bind:value="2"
              @change="checkNumLinhas"
            >
            <label class="form-label mb-0">Inativo</label>
          </div>
        </div>

        <!-- Botões de Ação -->
        <div class="flex items-center gap-4">
          <button type="button" class="btn-secondary uppercase" @click="goBack">
            Voltar
          </button>
          <button class="form-submit" type="submit">Salvar</button>
        </div>
      </div>
    </form>
  </div>
</template>
